/**
 * Shared Tailwind class fragments for `/tools/*` pages (JobCrawls public earth-tone / jc theme).
 */

/** Outer wrapper for title + description block above results */
export const TOOLS_SIDEBAR_WRAP =
  'text-jc-ink px-2 sm:px-2 md:px-4 pb-2 sm:pb-2 md:pb-4 flex flex-col gap-2 md:gap-3';

export const TOOLS_H1 = 'font-display text-2xl font-bold text-jc-ink';

export const TOOLS_LEAD = 'text-sm text-jc-muted';

export const TOOLS_EMPTY_TITLE = 'text-lg font-semibold text-jc-ink-secondary mb-2';

export const TOOLS_EMPTY_BODY = 'text-jc-muted text-base mb-2';

export const TOOLS_EMPTY_TIP = 'text-sm text-jc-contrast-subtle';

/** Primary control (e.g. “View results”) */
export const TOOLS_BTN_PRIMARY =
  'px-5 py-2 rounded-full font-semibold shadow-sm dark:shadow-none bg-jc-cta text-white hover:bg-jc-cta-hover transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-jc-accent focus-visible:ring-offset-2 focus-visible:ring-offset-jc-page';

/** Destructive control (delete, reset) */
export const TOOLS_BTN_DANGER =
  'px-5 py-2 rounded-full font-semibold shadow-sm dark:shadow-none bg-red-50 dark:bg-red-900/25 text-red-700 dark:text-red-300 border border-red-200 dark:border-red-800 hover:bg-red-100 dark:hover:bg-red-900/40 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-red-400 focus-visible:ring-offset-2 focus-visible:ring-offset-jc-page';

/** Compact destructive (toolbar) */
export const TOOLS_BTN_DANGER_SM =
  'flex-shrink-0 px-3 py-1.5 text-sm font-medium rounded-lg border border-red-200 dark:border-red-800 bg-red-50 dark:bg-red-900/25 text-red-700 dark:text-red-300 hover:bg-red-100 dark:hover:bg-red-900/40 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-red-400 focus-visible:ring-offset-2 focus-visible:ring-offset-jc-page';

/** Card / panel on tools pages */
export const TOOLS_PANEL =
  'bg-jc-surface rounded-2xl shadow-md dark:shadow-none border border-jc-border p-6 mb-6';

/** Tool switcher: active tab (add padding/rounded/text size in component) */
export const TOOLS_TAB_ACTIVE =
  'bg-jc-accent-muted text-jc-accent border border-jc-accent shadow-sm dark:shadow-none';

/** Tool switcher: inactive tab */
export const TOOLS_TAB_INACTIVE =
  'text-jc-ink-secondary border border-jc-border hover:bg-jc-elevated-hover hover:text-jc-ink';
